module.exports = __webpack_public_path__ + "img/banner-motor.52b5d98f.png";